module.exports = __webpack_public_path__ + "static/media/validate_tick_default.1c064fd1.svg";